var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { faCircleQuestion } from "@fortawesome/free-regular-svg-icons";
import { faSpinner, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { createRoot } from "react-dom/client";
import { Closable } from "../../models/Closable";
import { getConfigVar } from "../../utils/Configuration";
import { concatClassNames } from "../../utils/Functions";
import { Button } from "./Button";
import { Tooltip } from "./Tooltip";
var Dialog = /** @class */ (function (_super) {
    __extends(Dialog, _super);
    function Dialog(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidUpdate = function (prevProps, prevState) {
            if (prevProps.visible !== _this.props.visible)
                _this.setState({ visible: _this.props.visible });
            if (prevState.visible !== _this.state.visible)
                document.body.classList.toggle("dialog-showing", _this.state.visible);
        };
        _this.clickOnMask = function (e) {
            var _a = _this.props, closeOnMask = _a.closeOnMask, onCancel = _a.onCancel;
            if (!closeOnMask || !_this.node.isEqualNode(e.target))
                return;
            if (onCancel) {
                var value = onCancel("mask");
                if (typeof value === "boolean" && value)
                    _this.toggleDialog();
                else if (value.then) {
                    value.then(function (v) {
                        if (v)
                            _this.toggleDialog();
                    });
                }
            }
            else
                _this.toggleDialog();
        };
        _this.clickCancelButton = function () {
            var onCancel = _this.props.onCancel;
            if (onCancel) {
                var value = onCancel("cancel");
                if (typeof value === "boolean" && value)
                    _this.toggleDialog();
                else if (value.then) {
                    value.then(function (v) {
                        if (v)
                            _this.toggleDialog();
                    });
                }
            }
            else
                _this.toggleDialog();
        };
        _this.clickCloseButton = function () {
            var onCancel = _this.props.onCancel;
            if (onCancel) {
                var value_1 = onCancel("close");
                if (typeof value_1 === "boolean" && value_1)
                    _this.toggleDialog();
                else if (value_1.then) {
                    _this.toggleLoading().then(function () { return value_1.then(function (v) {
                        if (v)
                            _this.toggleDialog();
                    }); }).finally(_this.toggleLoading);
                }
            }
            else
                _this.toggleDialog();
        };
        _this.clickOkButton = function () {
            var onOk = _this.props.onOk;
            if (onOk) {
                var value_2 = onOk();
                if (typeof value_2 === "boolean" && value_2)
                    _this.toggleDialog();
                else if (value_2.then) {
                    _this.toggleLoading().then(function () { return value_2.then(function (v) {
                        if (v)
                            _this.toggleDialog();
                    }); }).finally(_this.toggleLoading);
                }
            }
            else
                _this.toggleDialog();
        };
        _this.toggleDialog = function () { return _this.setState({ visible: !_this.state.visible }); };
        _this.toggleLoading = function () { return new Promise(function (resolve) { return _this.setState({ loading: !_this.state.loading }, resolve); }); };
        _this.render = function () {
            var _a = _this.props, className = _a.className, title = _a.title, hideFooter = _a.hideFooter, customFooter = _a.customFooter, okButtonProps = _a.okButtonProps, cancelButtonProps = _a.cancelButtonProps, children = _a.children, width = _a.width, _b = _this.state, visible = _b.visible, loading = _b.loading;
            return React.createElement("div", { className: "dolfo-dialog-mask" + (visible ? " showing" : ""), onClick: _this.clickOnMask, ref: function (r) { return _this.node = r; } },
                React.createElement("div", { className: concatClassNames("dolfo-dialog", className), style: { width: width, minWidth: width } },
                    React.createElement("div", { className: "dolfo-dialog-header" },
                        React.createElement("h3", null, title),
                        React.createElement(Tooltip, { label: getConfigVar("CLOSE") },
                            React.createElement(Button, { className: "dolfo-dialog-close", color: "white", shape: "pill", onClick: _this.clickCloseButton, disabled: loading },
                                React.createElement(FontAwesomeIcon, { icon: faXmark, size: "lg" })))),
                    React.createElement("div", { className: "dolfo-dialog-content" }, children),
                    !hideFooter && React.createElement("div", { className: "dolfo-dialog-footer" },
                        loading && React.createElement(FontAwesomeIcon, { icon: faSpinner, className: "dialog-loader", spin: true }),
                        customFooter || React.createElement(React.Fragment, null,
                            React.createElement(Button, __assign({}, okButtonProps, { onClick: _this.clickOkButton, color: (okButtonProps === null || okButtonProps === void 0 ? void 0 : okButtonProps.color) || "blue2", size: okButtonProps === null || okButtonProps === void 0 ? void 0 : okButtonProps.size, className: (okButtonProps === null || okButtonProps === void 0 ? void 0 : okButtonProps.className) || "dolfo-ok-button", disabled: (okButtonProps === null || okButtonProps === void 0 ? void 0 : okButtonProps.disabled) || loading }), (okButtonProps === null || okButtonProps === void 0 ? void 0 : okButtonProps.children) || getConfigVar("OK")),
                            React.createElement(Button, __assign({}, cancelButtonProps, { color: (cancelButtonProps === null || cancelButtonProps === void 0 ? void 0 : cancelButtonProps.color) || "red", shape: (cancelButtonProps === null || cancelButtonProps === void 0 ? void 0 : cancelButtonProps.shape) || "text", onClick: _this.clickCancelButton, size: (cancelButtonProps === null || cancelButtonProps === void 0 ? void 0 : cancelButtonProps.size) || "small", disabled: (cancelButtonProps === null || cancelButtonProps === void 0 ? void 0 : cancelButtonProps.disabled) || loading }), (cancelButtonProps === null || cancelButtonProps === void 0 ? void 0 : cancelButtonProps.children) || getConfigVar("CANCEL"))))));
        };
        _this.state = {
            visible: props.visible || false,
            loading: false
        };
        return _this;
    }
    Dialog.confirm = function (title, message, onYes, onNo, onCancel) { return Dialog.open({
        title: React.createElement(React.Fragment, null,
            React.createElement(FontAwesomeIcon, { icon: faCircleQuestion, className: "fc-orange" }),
            " ",
            title),
        children: message,
        onCancel: function (t) {
            if ((t === "close" || t === "mask") && onCancel)
                return onCancel(t);
            if (t === "cancel" && onNo)
                return onNo(t);
            return true;
        },
        onOk: function () {
            if (onYes)
                return onYes();
            return true;
        },
        okButtonProps: { size: "small", shape: "pill" },
        cancelButtonProps: { size: "small", shape: "pill", color: "white" },
        width: 350,
        closeOnMask: true
    }); };
    Dialog.open = function (props) {
        var dialogRef;
        var container = document.createElement("div"), root = createRoot(container), close = function () {
            container.remove();
            setTimeout(function () { return root.unmount(); });
        }, onCancelFunction = function (e) {
            if (props.onCancel) {
                var value_3 = props.onCancel(e);
                if (typeof value_3 === "boolean" && value_3) {
                    close();
                    return true;
                }
                else if (value_3.then) {
                    return dialogRef.toggleLoading().then(function () { return value_3.then(function (v) {
                        if (v)
                            close();
                        return v;
                    }); }).finally(dialogRef.toggleLoading);
                }
            }
            close();
            return true;
        }, onOkFunction = function () {
            if (props.onOk) {
                var value_4 = props.onOk();
                if (typeof value_4 === "boolean" && value_4) {
                    close();
                    return true;
                }
                else if (value_4.then) {
                    return dialogRef.toggleLoading().then(function () { return value_4.then(function (v) {
                        if (v)
                            close();
                        return v;
                    }); }).finally(dialogRef.toggleLoading);
                }
            }
            close();
            return true;
        };
        root.render(React.createElement(Dialog, __assign({ ref: function (r) { return dialogRef = r; } }, props, { onCancel: onCancelFunction, onOk: onOkFunction, visible: true })));
        document.body.appendChild(container);
        return new Closable(close);
    };
    Dialog.openComponent = function (Class, props) {
        var popup = document.createElement("div"), root = createRoot(popup), closeFn = function () {
            popup.remove();
            setTimeout(function () { return root.unmount(); });
            return true;
        }, closable = new Closable(closeFn), Component = React.createElement(Class, __assign(__assign({}, props), { close: closable.close }));
        document.body.appendChild(popup);
        root.render(Component);
        return closable;
    };
    return Dialog;
}(React.Component));
export { Dialog };
